<template>
	<div class="row">
		<div class="col-12 mb-4 d-flex flex-row align-items-center">
			<h2 class="mr-auto">
				{{ $t('teachers') }}
			</h2>

			<button class="btn btn-outline-secondary" @click="zoom--" :disabled="zoom<=1"><b-icon icon="zoom-out"></b-icon></button>
			<button class="btn btn-outline-secondary ml-2" @click="zoom++" :disabled="zoom>=3"><b-icon icon="zoom-in"></b-icon></button>
			<router-link :to="`/timetables/individualteacher`" class="btn btn-outline-secondary ml-2">{{$t('individual-timetables')}}</router-link>
		</div>

		<div class="col-12 mb-4">
			<AdminTimetable
                ref="timetables"
				v-if="!loading"
				:from="from"
				:until="until"
				:minDate="from"
				:maxDate="until"
				:events="events"
				:groups="[this.noTeacherGroup, {id: -1, group_id: -1, year: 1, title: this.$t('events') }]"
				:students="teachers"
				:studentsAreTeachers="true"
				:zoom="zoom"
                :allowEdit="$UserSession.hasPriv.call(this, 'TIMETABLE_ADMIN')"
				@selectEvent="selectEvent"
				@selectUser="teacher => $router.push(`/timetables/individualteacher/${teacher.id}`)"
			/>

			<div v-else class="clearfix">
				<div v-for="n in Number(100)" :key="n" class="skeleton midnight h20 w100 float-left mb-3 mr-4" />
			</div>
		</div>
        <EventDetailsModal
			v-if="selectedEvent"
			v-model="modalVisible"
			:event="selectedEvent"
		/>
	</div>
</template>

<script>
import AdminTimetable from "src/components/Timetables/AdminTimetable.vue";
import EventDetailsModal from 'src/components/Timetables/EventDetailsModal.vue';
import SessionManager from "src/modules/session/sessionManager"

export default {
	components: {
		AdminTimetable,
        EventDetailsModal
	},
	data() {
		return {
			zoom: 3,
			timetable: [],
			rowHeadings:{},
			selectedEvent: {},
			showeventeditor: false,
			teachers: [],
			events: [],
			sessiontypes: [],
			from: null,
			until: null,
			loading: true,
			sessionTypesLoaded: null,
			noTeacherGroup: {id: -2, group_id: -2, year: 1, title: this.$t('no-staff-all-caps')},
            modalVisible: false,

            sessionManager: new SessionManager(this.$route)

		}
	},
	mounted() {
		Promise.all([
			this.fetchEvents(),
			this.fetchSessionTypes(),
			this.getTeachers()
		]).then(() => {
			this.loading = false
		})
	},
	methods: {
		getTeachers() {
			return this.$users.getTeachers.call(this).then(teachers => {
				this.teachers = teachers.map(teacher => {
					teacher.displayname = teacher.displayName
					return teacher
				})
				this.teachers.unshift({
					id: -1,
					displayname: this.$t('no-staff-all-caps'),
				})
			});
		},
		fetchEvents() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/teachers/events/all`, {
				method: 'GET',
                data: {
                	timetable_id: this.$route.params.timetableid
                }
			}).then(res => {
				this.sessionTypesLoaded.then(() => {
					this.events = this.processEvents(res.results)
					this.from = res.from
					this.until = res.to
				})
			})
		},
		fetchSessionTypes() {
            this.sessionTypesLoaded = this.$cfetch(`${this.$settings.APIBaseURL}/timetables/sessiontypes/all`, {
                method: 'GET'
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error()

                this.sessiontypes = res.results
            }).catch(err => {
                console.error(err)
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t('error-fetching-session-types'),
                })
            })

			return this.sessionTypesLoaded
        },
		processEvents(events) {
			if (!events.length) return []

			// Let's map session types and rooms by ID
			const roomsById = {}
			const sessionTypesById = this.sessiontypes.reduce((prev, curr) => {
				curr.ttrooms.forEach(room => roomsById[room.id] = room)
				prev[curr.id] = curr
				return prev
			}, {})

			return events.map(event => {
				// Our AdminTimetable and EventContainer class are built to sort events by students,
				// so we can quickly display teachers by setting them as students
				event.teachers = event.teachers || []
                event.students = event.teachers

				event.ttsessiontype = sessionTypesById[event.ttsessiontype_id]
				event.ttroom = roomsById[event.ttroom_id]

				let rot = 0
				let abs = 0
				let add = 0

				event.teachers.forEach(teacher => {
					if (teacher.on_rota) {rot++} else {add++}
					if (teacher.absent) {abs++}
				})

				if (!add && !(rot - abs)) event.groups = [this.noTeacherGroup]
				return event
			})
		},
        selectEvent(event) {
            //	@selectEvent="event => $router.push(`/timetables/${event.tttimetable_id}/events/${event.id}`)"

			if (this.$UserSession.hasPriv('TIMETABLE_ADMIN') && !event.modal) {
				const date = this.$refs.timetables[0]?.getLeftOfScreenDay().id.split('-').map((v, i) => {
					v = i === 1 ? Number(v) + 1 : Number(v)
					if (i > 0) {
						return v < 10 ? `0${v}` : `${v}`
					}
					return `${v}`
				}).join('-')

				this.sessionManager.set('from-date', date)
				this.$router.push(`/timetables/${event.tttimetable_id}/events/${event.id}`)
			}
			else {
				this.selectedEvent = event.event ? event.event : event
				this.modalVisible = true
			}
		}
	},
	computed: {
		tableClass: function(){
			if(this.zoom == 2){
				return 'table-timetable-sm';
			}
			if(this.zoom == 1){
				return 'table-timetable-xs';
			}
			return '';
		}
	}
};
</script>
